import React, { useState } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  CircularProgress,
  Alert
} from '@mui/material';
import { deleteJobDefinition } from 'graphql/mutations';

export const DeleteConfirmationModal = ({ job, onClose }) => {
  console.log('DeleteConfirmationModal - job received:', job);
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    setLoading(true);
    setError(null);

    try {
      await API.graphql(
        graphqlOperation(deleteJobDefinition, { 
          input: { jobDefinitionId: job.jobDefinitionId } 
        })
      );
      
      // Close modal and refresh the list
      onClose(true);
    } catch (err) {
      console.error('Error deleting job definition:', err);
      setError(err.message || 'Failed to delete job definition');
      // Don't close the modal if there's an error
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog 
      open={true} 
      onClose={() => !loading && onClose()}
    >
      <DialogTitle>Delete Job Definition</DialogTitle>
      
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the job definition "{job.name}"? 
          This action cannot be undone.
        </DialogContentText>
        
        {error && (
          <Alert severity="error" style={{ marginTop: '16px' }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      
      <DialogActions>
        <Button 
          onClick={() => onClose()} 
          disabled={loading}
          color="inherit"
        >
          Cancel
        </Button>
        <Button 
          onClick={handleDelete}
          disabled={loading}
          variant="contained"
          color="error"
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};